import { render, staticRenderFns } from "./BookShelfAction.vue?vue&type=template&id=1c92f6e4&scoped=true&"
import script from "./BookShelfAction.vue?vue&type=script&lang=js&"
export * from "./BookShelfAction.vue?vue&type=script&lang=js&"
import style0 from "./BookShelfAction.vue?vue&type=style&index=0&id=1c92f6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c92f6e4",
  null
  
)

export default component.exports